/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const chartOptions: any = {
  chart: {
    fontFamily: 'Inter',
    foreColor: '#262B40',
    toolbar: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      tools: {
        download: true,
        selection: false,
        zoom: false,
        zoomin: true,
        zoomout: true,
        pan: false,
        reset: false,
        customIcons: [],
      },
      export: {
        csv: {
          filename: undefined,
          columnDelimiter: ',',
          headerCategory: 'category',
          headerValue: 'value',
          dateFormatter(timestamp: any) {
            return new Date(timestamp).toDateString();
          },
        },
      },
      autoSelected: 'zoom',
    },
  },
  // plotOptions: {
  //   bar: {
  //     dataLabels: {
  //       position: 'top',
  //     },
  //   }
  // },
  // dataLabels: {
  //   enabled: true,
  //   formatter: function (val) {
  //     if (val != 0)
  //       return val;
  //   },
  //   offsetY: -22,
  //   style: {
  //     fontSize: '12px',
  //     colors: ["#304758"]
  //   }
  // },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    style: {
      fontSize: '14px',
      fontFamily: 'Inter',
    },
  },
  // theme: {
  //   monochrome: {
  //     enabled: true,
  //     color: '#17a5ce',
  //   }
  // },
  stroke: {
    curve: 'smooth',
  },
  grid: {
    show: false,
    borderColor: '#61DAFB',
    strokeDashArray: 1,
  },
  // markers: {
  //   size: 5,
  //   strokeColors: '#17a5ce',
  //   hover: {
  //     size: undefined,
  //     sizeOffset: 3
  //   }
  // },
  xaxis: {
    categories: null,
    labels: {
      style: {
        fontSize: '12px',
        fontWeight: 500,
      },
    },
    axisBorder: {
      color: '#000',
    },
    axisTicks: {
      color: '#000',
    },
  },
  yaxis: {
    labels: {
      style: {
        colors: ['#262B40'],
        fontSize: '12px',
        fontWeight: 500,
      },
    },
  },
  legend: {
    show: true,
    fontSize: '14px',
    fontFamily: 'Inter',
    fontWeight: 400,
    height: 60,
    tooltipHoverFormatter: undefined,
    offsetY: 20,
    markers: {
      width: 14,
      height: 14,
      strokeWidth: 1,
      strokeColor: '#fff',
      radius: 50,
    },
  },
  responsive: [
    {
      breakpoint: 768,
      options: {
        yaxis: {
          show: false,
        },
      },
    },
  ],
};
